import React from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getProductListing } from "../../../service/order/orderService";
import "../index.scss";
import { CardBody, Col, Row } from "react-bootstrap";
import ProductCard from "../component/productCards";

const Product = ({code}) => {
  const productData = useSelector(
    (state) => state.orders.selectedOrder.productData
  );
  useEffect(() => {
    if (code) {
      getProductListing(code);
    }
  }, [code]);
  return (
    <CardBody>
      <Row>
        {Array.isArray(productData) && productData.map((data, index) => {
          return <Col xs={12} sm={6} lg={4} key={index}>
            <ProductCard productDetail={data} index={index} code={code} />
          </Col>
        })}
      </Row>
    </CardBody>
  );
};

export default Product;
